import { Flex, PasswordInput, SimpleGrid, Text } from '@mantine/core'
import { Button } from 'components/Button'
import { useTranslation } from 'react-i18next'
import type { ChangePasswordSectionProps } from '../types'

/**
 * Form section for changing the user's password.
 * Includes current password verification and new password confirmation.
 */
export function ChangePasswordSection({
  currentPassword, newPassword, confirmPassword,
  saving, errors, onFieldChange, onSave,
}: ChangePasswordSectionProps) {
  const { t } = useTranslation()

  return (
    <div>
      <Text fw={600} size='lg' mb='md'>
        {t('my_profile.change_password')}
      </Text>

      <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
        <PasswordInput
          size='md'
          label={t('my_profile.current_password')}
          placeholder={t('my_profile.current_password_placeholder')}
          value={currentPassword}
          onChange={e => onFieldChange('currentPassword', e.currentTarget.value)}
          error={errors.currentPassword}
          required
        />
        <div />
      </SimpleGrid>

      <SimpleGrid cols={2} mt='md' breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
        <PasswordInput
          size='md'
          label={t('my_profile.new_password')}
          placeholder={t('my_profile.new_password_placeholder')}
          value={newPassword}
          onChange={e => onFieldChange('newPassword', e.currentTarget.value)}
          error={errors.newPassword}
          required
        />
        <PasswordInput
          size='md'
          label={t('my_profile.confirm_password')}
          placeholder={t('my_profile.confirm_password_placeholder')}
          value={confirmPassword}
          onChange={e => onFieldChange('confirmPassword', e.currentTarget.value)}
          error={errors.confirmPassword}
          required
        />
      </SimpleGrid>

      <Flex justify='flex-end' mt='sm'>
        <Button variant='filled' color='turquoise' onClick={onSave} loading={saving}>
          {t('my_profile.save')}
        </Button>
      </Flex>
    </div>
  )
}
